// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import DrawControl from 'react-mapbox-gl-draw'
import React from 'react'
import './index.less'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MapBoxDrawStyle from './MapBoxDrawStyle'
import geofenceIcon from '../../../assets/images/geofence.png'
import { Delete } from 'components/icon'
import { message, Tooltip } from 'antd'

const geofenceStyles = {
  selectable: 'solid',
  selected: 'dashed'
}

export class GeoFenceControl extends React.Component {
  drawControl = React.createRef()

  async handleDrawGeoFenceClick () {
    // const { geofencePoints } = this.props
    // const existGeoFence = geofencePoints && geofencePoints.length
    // let createNew = true
    // if (existGeoFence) {
    //   createNew = await new Promise(resolve => {
    //     Modal.confirm({
    //       title: 'Do you want to start draw a new Geofence?',
    //       onOk: () => resolve(true),
    //       onCancel: () => resolve(false)
    //     })
    //   })
    // }
    // if (createNew) {
    //   if (existGeoFence) {
    //     this.handleTrashClick()
    //   }
    //   this.drawControl.current.draw.changeMode(this.drawControl.current.draw.modes.DRAW_POLYGON)
    // }
    this.drawControl.current.draw.changeMode(this.drawControl.current.draw.modes.DRAW_POLYGON)
  }

  componentDidMount () {
    const { selectEnableList } = this.props
    selectEnableList.forEach(item => this.drawControl.current.draw.add(item))
    console.log('draw.getAll', this.drawControl.current.draw.getAll())
  }

  componentDidUpdate (prevProps) {
    if (this.props.needRefresh && prevProps.needRefresh !== this.props.needRefresh) {
      this.props.selectEnableList.forEach(item => {
        this.drawControl.current.draw.add(item)
      })
      this.props.setNeedRefresh(false)
    }
  }

  handleTrashClick () {
    const selectedIds = this.drawControl.current.draw.getSelectedIds()
    if (!selectedIds.length) {
      return message.info('Please delete after selecting.')
    }
    this.drawControl.current.draw.delete(selectedIds)
    const { onGeoFenceDelete } = this.props
    typeof onGeoFenceDelete === 'function' && onGeoFenceDelete()
  }

  handleDrawCreate (e) {
    const feature = e.features[0]
    const { addToSelectedEnable } = this.props
    addToSelectedEnable(feature)
  }

  handleDrawUpdate (e) {
    const { onGeoFenceUpdate } = this.props
    onGeoFenceUpdate(e.features[0])
  }

  handleSelectChange (e) {
    const { onGeoFenceUpdate } = this.props
    onGeoFenceUpdate(e.features[0])
  }

  render () {
    const { disabled } = this.props
    return (
      <div>
        <DrawControl
          styles={MapBoxDrawStyle}
          ref={this.drawControl}
          onDrawCreate={this.handleDrawCreate.bind(this)}
          onDrawUpdate={this.handleDrawUpdate.bind(this)}
          onDrawSelectionChange={this.handleSelectChange.bind(this)}
          displayControlsDefault={false}
        />
        {!disabled && (
          <div className='geo-draw-buttons'>
            <Tooltip title='Click this button then Click on Map to draw geofence'>
              <span onClick={this.handleDrawGeoFenceClick.bind(this)} className='geo-draw-button'>
                <img
                  src={geofenceIcon}
                  className='geofence-icon'
                  alt='geofence icon'
                  style={{ width: 14, height: 14 }}
                />
                Draw GeoFence
              </span>
            </Tooltip>

            <span onClick={this.handleTrashClick.bind(this)} className='geo-draw-button geo-draw-button-circle'>
              <Delete />
            </span>
          </div>
        )}
        <ul className='geofence-legend'>
          {Object.keys(geofenceStyles).map(key => (
            <li key={key}>
              {key}
              <span className='example' style={{ borderStyle: geofenceStyles[key] }} />
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

GeoFenceControl.propTypes = {
  onGeoFenceUpdate: PropTypes.func,
  onGeoFenceCreate: PropTypes.func,
  onGeoFenceDelete: PropTypes.func
}

const mapState2MapProps = ({ geofence, download }) => {
  return {
    selectEnableList: geofence.selectEnableList,
    needRefresh: geofence.needRefresh,
    disabled: download.mode === 'update'
  }
}
const mapDispatchToMapProps = ({ download, geofence }) => {
  const updateEditingPreTask = geoFence => {
    return download.updateEditingPreTask({ geoFence })
  }
  return {
    onGeoFenceCreate: updateEditingPreTask,
    onGeoFenceUpdate: updateEditingPreTask,
    onGeoFenceDelete: updateEditingPreTask,
    addToSelectedEnable: geofence.addToSelectedEnable,
    removeByIndex: geofence.removeByIndex,
    updateGeofence: geofence.updateGeofence,
    setNeedRefresh: geofence.setNeedRefresh
  }
}
export default connect(mapState2MapProps, mapDispatchToMapProps)(GeoFenceControl)
